import React from "react";
// iOS LogoWithText (client-native/src/ui/molecules/LogoWithText.tsx) uses the
// parrot logo image + the wordmark IMAGE (parrot-text.png), NOT live text — and
// a different, correct logo art (parrot.png), not the square app icon. Copied
// verbatim so the start screen matches iOS.
import logo from "../assets/parrot-logo-start.png";
import wordmark from "../assets/parrot-text-start.png";

const LogoAndText: React.FC = () => {
  return (
    // iOS: centered, gap 12; logo 160w with 8px bottom margin; wordmark 170×50.
    <div className="flex flex-col items-center" style={{ gap: 12 }}>
      <img
        src={logo}
        alt="Parrot"
        style={{ width: 160, height: "auto", marginBottom: 8 }}
      />
      <img
        src={wordmark}
        alt="parrot"
        style={{ width: 170, height: 50, objectFit: "contain" }}
      />
    </div>
  );
};

export default LogoAndText;
